import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing, gradientText, statusIconBase, typography } from 'stylesheet';
import { Clock, Close, Wifi, WifiOff } from 'theme/icons';
var Title = styled.h1.withConfig({
  displayName: "PublishDialogstyle__Title",
  componentId: "sc-fq5y1v-0"
})(["", " ", " margin-top:", ";"], typography.h1, gradientText, getSpacing(3));
var Container = styled.div.withConfig({
  displayName: "PublishDialogstyle__Container",
  componentId: "sc-fq5y1v-1"
})(["display:flex;flex-direction:column;align-items:center;width:600px;padding:0 40px;"]);
var Content = styled.div.withConfig({
  displayName: "PublishDialogstyle__Content",
  componentId: "sc-fq5y1v-2"
})(["display:flex;flex-direction:column;flex-grow:1;align-items:center;justify-content:center;"]);
var CloseButton = styled(Close).withConfig({
  displayName: "PublishDialogstyle__CloseButton",
  componentId: "sc-fq5y1v-3"
})(["position:absolute;right:", ";cursor:pointer;& path{fill:", ";}"], getSpacing(3), colorUsage.textColor);
var Description = styled.p.withConfig({
  displayName: "PublishDialogstyle__Description",
  componentId: "sc-fq5y1v-4"
})(["margin-top:", ";white-space:pre-wrap;text-align:center;"], getSpacing(1));
var ButtonContainer = styled.div.withConfig({
  displayName: "PublishDialogstyle__ButtonContainer",
  componentId: "sc-fq5y1v-5"
})(["margin-top:", ";text-align:center;"], getSpacing(2));
var CustomOfflineIcon = styled(WifiOff).withConfig({
  displayName: "PublishDialogstyle__CustomOfflineIcon",
  componentId: "sc-fq5y1v-6"
})(["", " path{fill:", ";}"], statusIconBase, colorUsage.status.icon.color.offline);
var CustomOnlineIcon = styled(Wifi).withConfig({
  displayName: "PublishDialogstyle__CustomOnlineIcon",
  componentId: "sc-fq5y1v-7"
})(["", " path{fill:", ";}"], statusIconBase, colorUsage.status.icon.color.online);
var CustomScheduledIcon = styled(Clock).withConfig({
  displayName: "PublishDialogstyle__CustomScheduledIcon",
  componentId: "sc-fq5y1v-8"
})(["", " path{fill:", ";}"], statusIconBase, colorUsage.status.icon.color.scheduled);
var Status = styled.div.withConfig({
  displayName: "PublishDialogstyle__Status",
  componentId: "sc-fq5y1v-9"
})(["position:absolute;left:", ";padding:0.1em 0.5em;border-radius:", ";&::before{margin-right:", ";content:'\u2022';}"], getSpacing(3), borderRadius.medium, getSpacing(1));
var StatusOffline = styled(Status).withConfig({
  displayName: "PublishDialogstyle__StatusOffline",
  componentId: "sc-fq5y1v-10"
})(["color:", ";background-color:", ";"], colorUsage.status.icon.color.offline, colorUsage.status.color.offline);
var StatusOnline = styled(Status).withConfig({
  displayName: "PublishDialogstyle__StatusOnline",
  componentId: "sc-fq5y1v-11"
})(["color:", ";background-color:", ";"], colorUsage.status.icon.color.online, colorUsage.status.color.online);
var StatusScheduled = styled(Status).withConfig({
  displayName: "PublishDialogstyle__StatusScheduled",
  componentId: "sc-fq5y1v-12"
})(["color:", ";background-color:", ";"], colorUsage.status.icon.color.scheduled, colorUsage.status.color.scheduled);
var Form = styled.form.withConfig({
  displayName: "PublishDialogstyle__Form",
  componentId: "sc-fq5y1v-13"
})(["margin-top:", ";"], getSpacing(2));
export { ButtonContainer, CloseButton, CustomOfflineIcon, CustomOnlineIcon, CustomScheduledIcon, Description, Form, Title, Container, Content, StatusOffline, StatusOnline, StatusScheduled };